import {
  animate,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';

const EnterLeavePostionQuery = query(
  ':enter, :leave',
  style({ position: 'absolute', width: '100%' }),
  { optional: true },
);

const EnterLeaveQueryAnimationQuery = (
  type: 'enter' | 'leave',
  motion: 'left' | 'right',
) => {
  const isEntering = type === 'enter';
  const isLeaving = type === 'leave';
  const isMovingLeft = motion === 'left';
  const isMovingRight = motion === 'right';

  const first =
    isEntering && isMovingLeft
      ? 'translateX(-100%)'
      : isEntering && isMovingRight
        ? 'translateX(100%)'
        : 'translateX(0)';

  const second =
    isLeaving && isMovingLeft
      ? 'translateX(100%)'
      : isLeaving && isMovingRight
        ? 'translateX(-100%)'
        : 'translateX(0)';

  return query(
    `:${type}`,
    [
      style({ transform: first }),
      animate('.3s ease-in-out', style({ transform: second })),
    ],
    { optional: true },
  );
};
const slide = (motion: 'left' | 'right') => {
  return group([
    EnterLeavePostionQuery,
    EnterLeaveQueryAnimationQuery('enter', motion),
    EnterLeaveQueryAnimationQuery('leave', motion),
  ]);
};

export const Animations = {
  leftRightSlider: trigger('leftRightSlider', [
    transition(':increment', slide('right')),
    transition(':decrement', slide('left')),
  ]),
};
